import * as React from 'react';

import { TableHeader } from '../components/ui/table.js';
import { cn } from '../lib/utils.js';

export function DimeTableHeader({
  className,
  sticky = false,
  ...props
}: Readonly<
  React.ComponentProps<typeof TableHeader> & {
    sticky?: boolean;
  }
>) {
  return (
    <TableHeader
      className={cn(
        // border-collapse drops a sticky row's border once the body scrolls under it, so cells paint an inset shadow.
        sticky && 'sticky top-0 z-10 bg-background [&_th]:shadow-[inset_0_-1px_0_0_var(--border)]',
        // Forced colors removes box-shadow, so a bordered ::after line stands in for the separator there.
        sticky &&
          'forced-colors:[&_th]:relative forced-colors:[&_th]:after:absolute forced-colors:[&_th]:after:inset-x-0 forced-colors:[&_th]:after:bottom-0 forced-colors:[&_th]:after:border-b',
        className,
      )}
      {...props}
    />
  );
}
